/**
 * @desc Implements operations for creating, reading and erasing cookies
 */
export default class CookieService {
  /**
   * @returns {boolean}
   */
  static get isCookiePolicyAccepted() {
    return CookieService.getCookie('hasConsent') === 'true';
  }

  /**
   * @param {string} name
   * @returns {string|null}
   * @see {@link https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/}
   */
  static getCookie(name) {
    const match = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);

    return match ? match[2] : null;
  }

  /**
   * @param {string} name
   * @param {string|number} value
   * @param {number} days
   * @see {@link https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/}
   */
  static setCookie(name, value, days) {
    const date = new Date(Date.now() + 24 * 60 * 60 * 1000 * days);

    document.cookie = `${name}=${value};expires=${date.toGMTString()};path=/`;
  }

  /**
   * @param {string} name
   * @see {@link https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/}
   */
  static deleteCookie(name) {
    CookieService.setCookie(name, '', -1);
  }
}
